import React, {useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import CheckboxWithTitledText from '#components/m/CheckboxWithTitledText'
import {DashboardNote} from '#components/m/MeineAusbildung/DashboardNote'
import {BerufwechselConfirmModal} from '#components/o/MeineAusbildung/BerufwechselConfirmModal'
import {BerufwechselConfirmModalContent} from '#components/o/MeineAusbildung/BerufwechselConfirmModalContent'
import Api from '#services/api'

export function BerufwechselNote({oldBerufTitle, newBerufTitle}) {
  const [ausbiludungsplanChecked, setAusbiludungsplanChecked] = useState(false)
  const [praxisaufgabenChecked, setPraxisaufgabenChecked] = useState(false)
  const checkboxenChecked = ausbiludungsplanChecked && praxisaufgabenChecked

  return (
    <DashboardNote
      title={i18n.t('berufwechsel_title')}
      text={i18n.t('berufwechsel_note_text', [oldBerufTitle, newBerufTitle])}
    >
      <CheckboxWithTitledText
        title={i18n.t('berufwechsel_title_ausbildungsplan')}
        text={i18n.t('berufwechsel_explanation_ausbilungsplan')}
        checked={ausbiludungsplanChecked}
        onChangeHandle={() => setAusbiludungsplanChecked(!ausbiludungsplanChecked)}
      />
      <CheckboxWithTitledText
        title={i18n.t('berufwechsel_title_praxisaufgaben')}
        text={i18n.t('berufwechsel_explanation_praxisaufgaben')}
        checked={praxisaufgabenChecked}
        onChangeHandle={() => setPraxisaufgabenChecked(!praxisaufgabenChecked)}
      />

      <BerufwechselConfirmModal
        disabled={!checkboxenChecked}
        headlineText={i18n.t('berufwechsel_confirmation_dialog_headline')}
        buttonText={i18n.t('berufwechsel_change_beruf_button')}
        apiCallback={async () => await Api.prepareReinitialization()}
      >
        <BerufwechselConfirmModalContent />
      </BerufwechselConfirmModal>
    </DashboardNote>
  )
}

BerufwechselNote.propTypes = {
  oldBerufTitle: PropTypes.string,
  newBerufTitle: PropTypes.string,
}

export default BerufwechselNote
